import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import Text from "components/ui/Text";
import { periodToString } from "services/pricingModel/utils";
import { formatMoney } from "utils/money";
import {
  DAYS_PER_MONTH,
  DAYS_PER_YEAR,
  PricingModelItem,
} from "../../../services/pricingModel/model";
import styles from "./styles.module.scss";

function FootNote({ pricingItem }: { pricingItem: PricingModelItem }) {
  const { t } = useTranslation();
  const dueValue =
    pricingItem.purchase_student_type === "one-on-one"
      ? `${formatMoney(pricingItem.price, pricingItem.currency)}/${periodToString(t, pricingItem.length!)}`
      : formatMoney(pricingItem.price, pricingItem.currency);

  if (pricingItem.purchase_student_type === "self-study") {
    let billingFrequency;
    if (
      pricingItem.length === DAYS_PER_MONTH ||
      pricingItem.length === DAYS_PER_MONTH + 1
    ) {
      billingFrequency = t("Common.billingFrequency.month");
    } else if (pricingItem.length === DAYS_PER_YEAR) {
      billingFrequency = t("Common.billingFrequency.year");
    } else {
      billingFrequency = t("Common.billingFrequency.days", {
        count: pricingItem.length!,
      });
    }

    return (
      <p className={styles.legalWarning}>
        {t("Common.checkout.subscriptionLegalNotice", {
          dueValue,
          billingFrequency,
        })}
      </p>
    );
  }

  if (pricingItem.purchase_student_type === "one-on-one") {
    return (
      <p className={styles.legalWarning}>
        {t("Common.checkout.oneOffLegalNotice", { dueValue })}
      </p>
    );
  }
  return <></>;
}

export default function CheckoutSummary({
  pricingItem,
  children,
}: {
  pricingItem: PricingModelItem;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  const isSelfStudy = pricingItem.purchase_student_type === "self-study";
  return (
    <div className={styles.root}>
      <div className={styles.dueContainer}>
        <Text variant="subtitle-3">{t("Common.checkout.totalDue")}</Text>
        <span className={styles.dueValue}>
          {formatMoney(pricingItem.price, pricingItem.currency)}
        </span>
        {isSelfStudy && (
          <Text variant="subtitle-3" className={styles.duePeriod}>
            /{periodToString(t, pricingItem.length!)}
          </Text>
        )}
      </div>
      {children}
      <FootNote pricingItem={pricingItem} />
    </div>
  );
}
